import React, { useState } from 'react'
import { getBEMCls } from '@/utils/classname'
import StockJoinCard from './stock-join-card'
import { ColumnsType } from 'antd/es/table'
import { Row } from '@/components/layout/layout'
import { IPurchaseOrder } from '../../../purchase-manage/purchase-order/modules/purchase-table/purchase-table'
import { Goods, Unit } from '@/model/types/goods'
import { IUser } from '@/model/types/user'
import $msg from '@/utils/message'
import { IPagination } from '@/model/types/common'
import { useRequest } from 'ahooks'
import { $post } from '@/api'
import { WithScrollLoad, AutoResizer } from '@/utils/utils-widget'
import { Table, Spin, Empty } from 'antd'
import { showLayer } from '@/utils/layer'
import StockJoinDetail from '../stock-join-detail/stock-join-detail'
import { ISupplier } from '@/model/types/supllier'

export interface StockInGoodsList extends IPurchaseOrder {
    goods: Goods
    stocking_in_amount: number
    stocked_in_amount: number
    purchase_price: number | null
    stock_in_unit: Unit
    supplier: ISupplier
    cost_price: number
    stock_in_unit_ratio: number
    direct_storage: number
}

export interface StockJoinList {
    stocked_in_amount: number
    order_goods_list: StockInGoodsList[]
    creator: {
        id: number
        user: IUser
    }
    stock_in_time: string
    order_no: string
    eta: string
    id: number
    source: 'purchase' | 'transfer'
    transfer_order_id: number | null
    transfer_order_no: string | null
}

interface StockJoinTableProps {
    date: string[]
}

const StockJoinTable: React.FC<StockJoinTableProps> = props => {
    const cls = (...arg: string[]) => getBEMCls('stock-join', ...arg)

    const [stockInOrder, setStockInOrder] = useState<StockJoinList[]>([])

    const [update, setUpdate] = useState<boolean>(false)

    const { loading } = useRequest(
        () =>
            $post({
                url: '/warehouse/getstockinorders',
                params: {
                    desc: false,
                    include_order_goods: true,
                    limit: 100,
                    order_by: 'eta',
                    page: 1,
                    stocked_in: false,
                },
            }),
        {
            onSuccess: res => {
                setStockInOrder(res.orders)
            },
            refreshDeps: [update],
        },
    )

    const columns: ColumnsType<StockJoinList> = [
        {
            title: '#',
            key: 'index',
            width: 50,
            render: (value, record, index) => index + 1,
        },
        {
            title: '入库日期',
            key: 'stock_in_time',
            dataIndex: 'stock_in_time',
        },
        {
            title: '操作人',
            key: 'creator',
            dataIndex: 'creator',
            render: val => (
                <Row data-align-items-center>
                    <img src={val.user.avatar} alt="" className="avatar" />
                    <div data-margin-left-4> {val.user.realname || val.user.nickname}</div>
                </Row>
            ),
        },
        {
            title: '商品数',
            key: 'stocked_in_amount',
            dataIndex: 'stocked_in_amount',
        },
        {
            title: '操作',
            key: 'action',
            width: 90,
            align: 'center',
            render: (val, record) => (
                <span
                    className="action"
                    onClick={() => {
                        showLayer(<StockJoinDetail id={record.id} />)
                    }}
                >
                    详情
                </span>
            ),
        },
    ]

    const requestHandle = useRequest<
        {
            list: StockJoinList[]
            pagination: IPagination
        },
        {
            orders: StockJoinList[]
            pagination: IPagination
        }
    >(
        val => {
            return $post({
                url: '/warehouse/getstockinorders',
                params: {
                    limit: 20,
                    page: val?.pagination?.page ? val.pagination.page + 1 : 1,
                    order_by: 'stock_in_time',
                    stocked_in: true,
                    desc: true,
                    stocked_in_from_date: props.date[0],
                    stocked_in_to_date: props.date[1],
                },
            })
        },
        {
            isNoMore: data => {
                if (data?.pagination) {
                    return data?.pagination.page === data?.pagination.page_count
                } else {
                    return false
                }
            },
            loadMore: true,
            formatResult: data => {
                return {
                    list: data.orders,
                    pagination: data.pagination,
                }
            },
            onError: e => {
                $msg('error', e.message)
            },
            refreshDeps: [props.date, update],
        },
    )

    return (
        <div className={cls('table-container')}>
            {!!stockInOrder.length && (
                <>
                    <div className={cls('title')}>待入库单 ({stockInOrder.length})</div>
                    <Spin spinning={loading}>
                        <div className={stockInOrder.length ? cls('card-container') : cls('card-container-empty')}>
                            {stockInOrder.length ? (
                                stockInOrder.map(order => (
                                    <StockJoinCard
                                        refresh={() => {
                                            setUpdate(!update)
                                        }}
                                        key={order.id}
                                        stockInOrder={order}
                                    />
                                ))
                            ) : (
                                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="暂无待入库单" />
                            )}
                        </div>
                    </Spin>
                </>
            )}
            <div className={cls('title')}>已入库单</div>
            <AutoResizer>
                {({ height }) => {
                    return (
                        <WithScrollLoad data-expaned data-overflow-hidden scrollloadhandle={requestHandle}>
                            <Table
                                rowKey={record => record.id}
                                loading={requestHandle.loading || requestHandle.loadingMore || void 0}
                                bordered
                                pagination={false}
                                columns={columns}
                                dataSource={requestHandle.data?.list}
                                scroll={{ x: 'max-content', y: height - 50 }}
                            />
                        </WithScrollLoad>
                    )
                }}
            </AutoResizer>
        </div>
    )
}

export default StockJoinTable
